import { FC } from 'react'

import { Col, Span } from 'components'

import { IListaContratos } from '../..'
import { CardItem } from './components'
import { CardList } from './components/CardItem/CardItem.styles'
import { CardContainer, ContenctCard, LineTop } from './styles'

interface CardContractsProps {
  list: IListaContratos[]
  onClick: (_index: number) => void
  title: string
  isExpanded?: boolean
}

const CardContracts: FC<CardContractsProps> = ({ list, onClick, title }) => {
  return (
    <Col>
      <Span
        text={title}
        fontSize="1.3rem"
        fontWeight="600"
        marginBottom="1rem"
      />

      <CardContainer>
        <LineTop />
        <ContenctCard>
          {list?.map((contract, index) => (
            <CardList key={`${contract.content.idContrato}-key-${index}`}>
              <li onClick={() => onClick(index)}>
                <CardItem contract={contract} />
              </li>
            </CardList>
          ))}
        </ContenctCard>
      </CardContainer>
    </Col>
  )
}

export default CardContracts
